export const ISN93 = "ISN93";
export const WGS84 = "WGS84";
